module.exports = __webpack_public_path__ + "7aa57e5bedcc2b5a172ea8674a459f1c.svg";